import { call, select, takeEvery } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';
import type { CoreActionCreator, QcsSyncResourcesConfigProps } from '../core/resourceStoreTypes';

import { getCreditProfile } from '../credit-profile/selectors';

import * as actions from './actions';
import { type CreditReportType, mkCreditReport } from './types';

const mkQcsSyncCreditReportConfig = resourceStoreTypes.createTypedQcsSyncResourcesConfigFactory<CreditReportType>();

export const mkResourceConfig = (
  successAction: CoreActionCreator<any, any>,
  failureAction: CoreActionCreator<any, any>,
  query = '',
  transformResourceWithResponse: QcsSyncResourcesConfigProps<CreditReportType>['transformResourceWithResponse'] = (
    resource,
    response,
  ) => mkCreditReport({ ...response.data, ...resource }),
) =>
  mkQcsSyncCreditReportConfig({
    resourceName: 'credit-report',
    resourceBaseUrl: `/creditscore/credit-report${query}`,
    successAction,
    failureAction,
    transformResponseToResource: (response) => mkCreditReport(response?.data),
    transformResourceWithResponse,
  });

export function* getCreditReportActionWatcher() {
  yield takeEvery(actions.getCreditReport.type, function* handle() {
    const { id } = yield select(getCreditProfile);
    const config = mkResourceConfig(
      actions.getCreditReportSuccess,
      actions.getCreditReportFailure,
      `?creditProfileRegistationId=${id}`,
    );
    yield call(resourceSagaUtils.qcsSyncGetResource<CreditReportType>, config);
  });
}

export function* refreshCreditReportActionWatcher() {
  const config = mkResourceConfig(
    actions.refreshCreditReportSuccess,
    actions.refreshCreditReportFailure,
    `/refresh`,
    (_resource, response) => mkCreditReport({ ...response.data }),
  );
  yield takeEvery(actions.refreshCreditReport.type, resourceSagaUtils.qcsSyncCreateResource<CreditReportType>, config);
}

export function* refetchCreditReportActionWatcher() {
  const config = mkResourceConfig(
    actions.getRefreshedCreditReportSuccess,
    actions.getRefreshedCreditReportFailure,
    `/refresh`,
    (_resource, response) => mkCreditReport({ ...response.data, isRefreshed: true }),
  );
  yield takeEvery(
    actions.getRefreshedCreditReport.type,
    resourceSagaUtils.qcsSyncCreateResource<CreditReportType>,
    config,
  );
}

export default [getCreditReportActionWatcher, refreshCreditReportActionWatcher, refetchCreditReportActionWatcher];
